module.exports = __webpack_public_path__ + "img/tag-precio.2dcd2112.png";